export const getAPIBase = (mode) => {
    switch (mode) {
        case 'production':
            return '';
        case 'staging':
            return '/php-files';
        case 'development':
        default:
            return 'http://snowdomeww.local/php-files';
    }
};
export const getAPIRoutes = (mode) => {
    switch (mode) {
        case 'production':
            return {
                readProducts: 'umbraco/Surface/AjaxHandlerSurface/ReadProduct',
                hasSessions: 'umbraco/Surface/AjaxHandlerSurface/HasSessions',
                hasSessionsWithStock: 'umbraco/Surface/AjaxHandlerSurface/HasSessionsWithStock',
                hasDaySessions: 'umbraco/Surface/AjaxHandlerSurface/HasDaySessions',
                hasDaySessionsWithStock: 'umbraco/Surface/AjaxHandlerSurface/HasDaySessionsWithStock',
                reserveSession: 'umbraco/Surface/AjaxHandlerSurface/ReserveSession',
                reserveDayTicket: 'umbraco/Surface/AjaxHandlerSurface/ReserveDayTicket',
                getSessions: 'umbraco/Surface/AjaxHandlerSurface/Availability',
                readPrices: 'umbraco/Surface/AjaxHandlerSurface/ReadPrices',
                dayPrices: 'umbraco/Surface/AjaxHandlerSurface/DayPrices',
                levelChange: 'umbraco/Surface/AjaxHandlerSurface/LevelChange',
                search: 'umbraco/Surface/AjaxHandlerSurface/Search',
                adjustProductQty: 'umbraco/Surface/AjaxHandlerSurface/AdjustProductQty',
                adjustMiscProductQty: 'umbraco/Surface/AjaxHandlerSurface/AdjustMiscQty',
                addMisc: 'umbraco/Surface/AjaxHandlerSurface/AddMiscellaneous',
                adjustUpsellProductQty: 'umbraco/Surface/AjaxHandlerSurface/AdjustMiscQty',
                trashProduct: 'umbraco/Surface/AjaxHandlerSurface/TrashProduct',
                trashMiscProduct: 'umbraco/Surface/AjaxHandlerSurface/TrashMisc',
                trashUpsellProduct: 'umbraco/Surface/AjaxHandlerSurface/TrashUpsell',
                verifyCaptcha: 'umbraco/Surface/AjaxHandlerSurface/Verify',
                addUpsellItem: 'umbraco/Surface/AjaxHandlerSurface/AddUpsellItem',
                addVoucher: 'umbraco/Surface/AjaxHandlerSurface/AddVoucherCode',
                giftVoucher: 'umbraco/Surface/AjaxHandlerSurface/AddGiftVoucher',
                addGiftVoucher: 'umbraco/Surface/AjaxHandlerSurface/CheckGiftVoucher',
                getActivitySessions: 'umbraco/Surface/AjaxHandlerSurface/ActivitySessions',
                hasAvailability: 'umbraco/Surface/AjaxHandlerSurface/HasAvailability',
                dayTicketAvailability: 'umbraco/Surface/AjaxHandlerSurface/HasAvailability',
                register: 'umbraco/Surface/AjaxHandlerSurface/Register',
                login: 'umbraco/Surface/AjaxHandlerSurface/Login',
                logout: 'umbraco/Surface/AjaxHandlerSurface/Signout',
                loginChild: 'umbraco/Surface/AjaxHandlerSurface/ChildLogin',
                forgotPassword: 'umbraco/Surface/AjaxHandlerSurface/ForgotPassword',
                resetPassword: 'umbraco/Surface/AjaxHandlerSurface/ResetPassword',
                changePassword: 'umbraco/Surface/AjaxHandlerSurface/ChangePassword',
                activitiesAvailableOnDate: 'umbraco/Surface/AjaxHandlerSurface/ActivitiesForDate',
                modifyAccount: 'umbraco/Surface/AjaxHandlerSurface/ModifyAccount',
                cancelBooking: 'umbraco/Surface/AjaxHandlerSurface/CancelBooking',
                newsletterRegistration: 'umbraco/Surface/AjaxHandlerSurface/NewsletterRegistration',
                signature: 'umbraco/Surface/AjaxHandlerSurface/Signature',
                directDebit: 'umbraco/Surface/AjaxHandlerSurface/DirectDebit',
                retentionRegistration: 'umbraco/Surface/AjaxHandlerSurface/NewsletterRegistration',
            };
        case 'development':
        case 'staging':
        default:
            return {
                readProducts: 'readProduct.php',
                hasSessions: 'hasSessions.php',
                hasSessionsWithStock: 'hasSessionsWithStock.php',
                hasDaySessions: 'hasDaySessions.php',
                hasDaySessionsWithStock: 'hasDaySessionsWithStock.php',
                reserveSession: 'reserveSession.php',
                reserveDayTicket: 'reserveDayTicket.php',
                getSessions: 'getSessions.php',
                getActivitySessions: 'activitySessions.php',
                readPrices: 'readPrices.php',
                dayPrices: 'dayPrices.php',
                levelChange: 'levelChange.php',
                search: 'search.php',
                adjustMiscProductQty: 'adjustMiscQty.php',
                addMisc: 'addMisc.php',
                adjustProductQty: 'adjustProductQty.php',
                adjustUpsellProductQty: 'adjustUpsellQty.php',
                trashProduct: 'trashProduct.php',
                trashUpsellProduct: 'trashUpsellProduct.php',
                trashMiscProduct: 'trashMiscProduct.php',
                verifyCaptcha: 'verifyCaptcha.php',
                addUpsellItem: 'addUpsell.php',
                addVoucher: 'addVoucherCode.php',
                giftVoucher: 'AddGiftVoucher.php',
                addGiftVoucher: 'CheckGiftVoucher.php',
                hasAvailability: 'hasAvailability.php',
                dayTicketAvailability: 'dayTicketAvailability.php',
                register: 'register.php',
                login: 'login.php',
                logout: 'signout.php',
                loginChild: 'loginChild.php',
                forgotPassword: 'forgotPassword.php',
                resetPassword: 'resetPassword.php',
                changePassword: 'changePassword.php',
                activitiesAvailableOnDate: 'activitiesAvailableForDate.php',
                modifyAccount: 'modifyAccount.php',
                cancelBooking: 'cancelBooking.php',
                newsletterRegistration: 'newsletterRegistration.php',
                signature: 'signature.php',
                directDebit: 'directDebit.php',
                retentionRegistration: 'retentionRegistration.php',
            };
    }
};
